import {TaskTemplateData} from '@dv5/domain'
import React, {FC} from 'react'
import {TaskTemplateEditor} from './TaskTemplateEditor'
import {ViewMode} from './useTemplateDataEditor'

interface Props {
    initialTaskFormData: TaskTemplateData
    formTaskData: TaskTemplateData
    onTaskDataChange: (data: TaskTemplateData) => void
    onConfirm: () => void
    onCancel: () => void
    viewMode: ViewMode
}

export const TaskTemplateContent: FC<Props> = ({
    initialTaskFormData,
    formTaskData,
    onTaskDataChange,
    onConfirm,
    onCancel,
    viewMode,
}) => {
    if (viewMode === 'formEdit') {
        return (
            <TaskTemplateEditor
                data={formTaskData}
                onChange={onTaskDataChange}
                onConfirm={onConfirm}
                onCancel={onCancel}
            />
        )
    }

    return (
        <div className="template-data-form">
            <div className="template-data-form-field">
                <label className="template-data-form-label">Title</label>
                <div className="template-data-form-value">{initialTaskFormData.title}</div>
            </div>
            <div className="template-data-form-field template-data-form-field-content">
                <label className="template-data-form-label">Description</label>
                <div className="template-data-form-value template-data-form-value-multiline">{initialTaskFormData.description}</div>
            </div>
            <div className="template-data-form-field">
                <label className="template-data-form-label">Webhook URL</label>
                <div className="template-data-form-value">{initialTaskFormData.webHookUrl}</div>
            </div>
        </div>
    )
}
